// src/components/shared/useIsDesktop.js
// Nutzt dieselbe Breakpoint-Grenze wie die bestehenden Mobile-Layout-Regeln in
// App.css (@media max-width: 700px), damit JS- und CSS-Verhalten übereinstimmen.
// "Desktop" heißt hier schlicht "breiter Viewport", nicht zwingend "kein Touch"
// - ein breites Tablet zählt bewusst als Desktop.
import { useState, useEffect } from 'react';

const QUERY = '(min-width: 701px)';

export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handler = (e) => setIsDesktop(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isDesktop;
}

export default useIsDesktop;